module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "annual-norm text-dark"
  }, [_c('div', {
    staticClass: "d-header"
  }, [_c('div', {
    staticClass: "d-header__left"
  }, [_c('h1', [_vm._v("Årsnorm")]), _vm._v(" "), _c('ChangeSchoolYear', {
    attrs: {
      "whiteTheme": true
    }
  })], 1)]), _vm._v(" "), (_vm.isLoading && !_vm.isUpdatingTasks) ? _c('Loader') : [_c('div', {
    staticClass: "d-tabs"
  }, [_c('div', {
    staticClass: "d-tabs__tab",
    class: {
      'd-tabs__tab--active': !_vm.viewIsResult
    },
    on: {
      "click": function($event) {
        _vm.viewIsResult = false
      }
    }
  }, [_vm._v("\n        Tildel opgaver\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "d-tabs__tab",
    class: {
      'd-tabs__tab--active': _vm.viewIsResult
    },
    on: {
      "click": function($event) {
        _vm.viewIsResult = true
      }
    }
  }, [_vm._v("\n        Se opgørelse\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "d-tabs__container"
  }, [(_vm.viewIsResult) ? [_c('AnnualNormResult', {
    attrs: {
      "schoolId": _vm.schoolId,
      "users": _vm.userWithProps
    },
    on: {
      "setIsShowEmploymentEnded": _vm.setIsShowEmploymentEnded
    }
  })] : _c('div', {
    staticClass: "annual-norm__body"
  }, [_c('div', {
    staticClass: "annual-norm__body__left"
  }, [_c('AssignHoursNorm', {
    staticClass: "marg-1-bottom",
    attrs: {
      "isKindergarten": true
    },
    on: {
      "updateUsersHours": _vm.readAssignedHours
    }
  }), _vm._v(" "), _c('ul', _vm._l((_vm.userWithProps), function(user) {
    return _c('li', {
      key: user.user_calendar_id,
      staticClass: "user-item",
      class: {
        'user-item--active': user.v_is_active_user
      }
    }, [_c('div', {
      staticClass: "user-item__body",
      on: {
        "click": function($event) {
          return _vm.setActiveUserId(user.id)
        }
      }
    }, [_c('div', {
      staticClass: "user-item__name"
    }, [(user.default_thumb_url) ? _c('img', {
      staticClass: "user-item__name__img",
      attrs: {
        "src": user.default_thumb_url,
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(user.name))])]), _vm._v(" "), _c('div', {
      staticClass: "user-item__right"
    }, [_c('div', {
      staticClass: "user-item__hours"
    }, [_c('p', [_c('label', {
      staticClass: "d-label"
    }, [_vm._v("Arb. tid")]), _c('span', [_vm._v(_vm._s(user.v_assigned_total_hours))])]), _vm._v(" "), _c('p', [_c('label', {
      staticClass: "d-label"
    }, [_vm._v("Uden børn")]), _c('span', [_vm._v(_vm._s(user.v_total_without_kids))])]), _vm._v(" "), _c('p', [_c('label', {
      staticClass: "d-label"
    }, [_vm._v("Med børn")]), _c('span', [_vm._v(_vm._s(user.v_total_with_kids))])])]), _vm._v(" "), _c('div', {
      staticClass: "user-item__arrow"
    }, [(!user.v_is_active_user) ? _c('span', {
      staticClass: "icon-arrow-right4"
    }) : _c('span', {
      staticClass: "icon-arrow-down4"
    })])])]), _vm._v(" "), (user.v_is_active_user) ? _c('div', {
      staticClass: "user-item__tasks"
    }, [(!_vm.activeNorm) ? _c('Loader', {
      attrs: {
        "isSmall": true,
        "bg-color": "#fff"
      }
    }) : _c('table', {
      staticClass: "d-table d-table__norm d-table__tasks marg-10-bottom"
    }, [_c('thead', [_c('tr', [_c('th', {
      staticClass: "d-table__title",
      attrs: {
        "colspan": "2"
      }
    }, [_c('h4', [_vm._v("Norm")])])])]), _vm._v(" "), _c('tbody', [(_vm.activeNorm.length < 1) ? _c('tr', [_c('td', [_vm._v("Ingen opgaver uden børn")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.activeNormFormatted), function(item) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.value))])])
    })], 2)]), _vm._v(" "), _c('table', {
      staticClass: "d-table d-table__tasks marg-10-bottom"
    }, [_c('thead', [_c('tr', [_c('th', {
      staticClass: "d-table__title",
      attrs: {
        "colspan": "2"
      }
    }, [_c('h4', [_vm._v("Opgaver uden børn")])])])]), _vm._v(" "), _c('tbody', [(user.v_user_tasks_without_kids.length < 1) ? _c('tr', [_c('td', [_vm._v("Ingen opgaver uden børn")])]) : _vm._e(), _vm._v(" "), _vm._l((user.v_user_tasks_without_kids), function(task) {
      return _c('tr', {
        key: task.id
      }, [_c('td', [_c('div', {
        staticClass: "task-with-edit"
      }, [(task.can_schedule || !task.hasOwnProperty('can_schedule')) ? _c('div', {
        staticClass: "subjects_subject subjects_subject__simple",
        style: ([{
          'border-left-color': task.color
        }, {
          'background-color': task.color
        }])
      }, [_vm._v("\n                          " + _vm._s(task.name) + "\n                        ")]) : _c('div', {
        staticClass: "subjects_subject subjects_subject--not-subject"
      }, [_vm._v(_vm._s(task.name))])])]), _vm._v(" "), _c('td', {
        staticClass: "is-number"
      }, [_vm._v("\n                      " + _vm._s(task.hours) + "\n                    ")])])
    })], 2)]), _vm._v(" "), _c('table', {
      staticClass: "d-table d-table__tasks marg-10-bottom"
    }, [_c('thead', [_c('tr', [_c('th', {
      staticClass: "d-table__title",
      attrs: {
        "colspan": "2"
      }
    }, [_c('h4', [_vm._v("Opgaver med børn")])])])]), _vm._v(" "), _c('tbody', [(user.v_user_tasks_with_kids.length < 1) ? _c('tr', [_c('td', [_vm._v("Ingen opgaver med børn")])]) : _vm._e(), _vm._v(" "), _vm._l((user.v_user_tasks_with_kids), function(task) {
      return _c('tr', {
        key: task.id
      }, [_c('td', [_c('div', {
        staticClass: "task-with-edit"
      }, [(task.can_schedule || !task.hasOwnProperty('can_schedule')) ? _c('div', {
        staticClass: "subjects_subject subjects_subject__simple",
        style: ([{
          'border-left-color': task.color
        }, {
          'background-color': task.color
        }])
      }, [_vm._v("\n                          " + _vm._s(task.name) + "\n                        ")]) : _c('div', {
        staticClass: "subjects_subject subjects_subject--not-subject"
      }, [_vm._v(_vm._s(task.name))])])]), _vm._v(" "), _c('td', {
        staticClass: "is-number"
      }, [_vm._v("\n                      " + _vm._s(task.hours) + "\n                    ")])])
    })], 2)])], 1) : _vm._e()])
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "annual-norm__body__right"
  }, [_c('div', {
    staticClass: "annual-norm__body__right__header"
  }, [_c('div', {
    staticClass: "flipper-buttons"
  }, [_c('button', {
    staticClass: "flipper-buttons__button",
    class: {
      'active': _vm.isTasksView
    },
    on: {
      "click": function($event) {
        _vm.isTasksView = true
      }
    }
  }, [_c('span', {
    staticClass: "icon-file-text"
  }), _vm._v("\n                Uden børn\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "flipper-buttons__button",
    class: {
      'active': !_vm.isTasksView
    },
    on: {
      "click": function($event) {
        _vm.isTasksView = false
      }
    }
  }, [_c('span', {
    staticClass: "icon-year-planning"
  }), _vm._v("\n                Med børn\n              ")])])]), _vm._v(" "), (!_vm.isTasksView) ? _c('AnnualNormWithKids') : _vm._e(), _vm._v(" "), (_vm.isTasksView) ? _c('AnnualNormWithoutKids') : _vm._e()], 1)])], 2)], _vm._v(" "), (_vm.isShowEmploymentEnded) ? _c('DModal', {
    attrs: {
      "isBgOverlay": true,
      "show-close": false
    },
    on: {
      "close": function($event) {
        return _vm.setIsShowEmploymentEnded(false)
      }
    }
  }, [_c('div', {
    staticClass: "do-modal",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "do-modal__header"
  }, [_c('h2', [_vm._v("Brudt ansættelse")]), _vm._v(" "), _c('div', {
    staticClass: "icon__bg-circle ww-modal__header__close",
    on: {
      "click": function($event) {
        return _vm.setIsShowEmploymentEnded(false)
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "do-modal__body"
  }, [_c('AssignHoursEmploymentEnded', {
    attrs: {
      "schoolId": _vm.schoolId,
      "users": _vm.userWithProps
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "d-modal"
    }
  }, [(_vm.isConfirmDeletion) ? _c('ModalConfirmation', {
    attrs: {
      "showClose": false
    },
    on: {
      "close": function($event) {
        return _vm.$store.commit('setConfirmDeletion', false)
      },
      "confirm": _vm.confirmDelete
    }
  }, [_c('h3', {
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_vm._v(_vm._s(_vm.itemToDelete.name))])]) : _vm._e()], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-be090830!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AnnualNorm/AnnualNorm.vue
// module id = 2112
// module chunks = 1